import * as React from "react"
import { Box } from "@mui/material"
import {IconSeeker} from "@ui-seeker/core";

import {SitesChipBlock} from "../@components"
import {userDetailModalFilters} from "../../@signals";



export default function sitesScopeColumn() {
    return {
        name: "sitesScope", label: 'Sites Scope',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { maxWidth: 140 } }),
            customBodyRowRenderLite: (value, row) => {
                const sitesToShow = value.slice(0, 4)

                return <Box display={'flex'} flexDirection={"column"} justifyContent={'center'} alignItems={'center'}>
                    <SitesChipBlock listElements={sitesToShow} />
                    <IconSeeker
                        icon="circle-info"
                        tooltip="See user full info"
                        sx={{ ml: 1, fontSize: '1rem', cursor: 'pointer'  }}
                        onClick={() => {
                            userDetailModalFilters.value = row
                        }}
                    />
                </Box>

            }
        }
    }
}